// src/api.js
export async function req(path, { method = "GET", body } = {}) {
  const opt = { method, headers: {}, credentials: "include" };
  if (body !== undefined) {
    opt.headers["Content-Type"] = "application/json";
    opt.body = JSON.stringify(body);
  }
  const r = await fetch(path, opt);
  let j;
  try {
    j = await r.json();
  } catch {
    j = { ok: false, error: "Non-JSON response", status: r.status };
  }
  return { httpStatus: r.status, json: j };
}
